<footer *ngIf="!isMobileRender" class="footer content-max-width">
  <footer-menu [menuItems]="menuItems"></footer-menu>

  <section class="footer__section footer__section--country-and-apps">
    <div class="footer__section-item">
      <p class="footer__section-heading">ACKNOWLEDGEMENT OF COUNTRY</p>
      <p class="footer__section-body">
        Zip acknowledges the Traditional Owners and Custodians of Country throughout Australia. We
        pay our respects to all First Nations people and acknowledge Elders past and present.
      </p>
    </div>

    <div class="footer__section-item">
      <p class="footer__section-heading">DOWNLOAD THE APP</p>

      <ul class="footer__list footer__list--app">
        <li *ngFor="let appItem of appItems">
          <a class="footer__list-link" [href]="appItem.link" target="_blank">
            <img [src]="appItem.iconSrc" [alt]="appItem.alt" [attr.loading]="'lazy'" width="132" />
          </a>
        </li>
      </ul>
    </div>
  </section>

  <section class="footer__section footer__section--legal-socials">
    <p class="footer__section-body">
      Copyright © Zip Co Limited {{ year }}. This site is protected by reCAPTCHA Enterprise and the
      Google
      <a class="footer__section-link" href="https://policies.google.com/privacy" target="_blank"
        >Privacy Policy</a
      >
      and
      <a class="footer__section-link" href="https://policies.google.com/terms" target="_blank"
        >Terms of Service</a
      >
      apply.
    </p>

    <div class="footer__section-item">
      <ul class="footer__list footer__list--legal">
        <li *ngFor="let legalItem of legalItems">
          <a class="footer__list-link" [href]="legalItem.link">
            {{ legalItem.label }}
          </a>
        </li>
      </ul>

      <ul class="footer__list footer__list--social">
        <li *ngFor="let socialItem of socialItems">
          <a class="footer__list-link" [href]="socialItem.link" target="_blank">
            <img
              [src]="socialItem.iconSrc"
              [alt]="socialItem.alt"
              [attr.loading]="'lazy'"
              width="20"
            />
          </a>
        </li>
      </ul>
    </div>
  </section>
</footer>
